import Vue from 'vue';

export function localisedNumber(value: string | number | unknown[]): string {
  if (value === null || value === undefined) {
    return;
  }
  const numberAsString = value.toString().split('.')[0];
  const number = Number(numberAsString).toLocaleString(Vue.config.lang);
  return number;
}

export function localisedPunctuation(
  value: string | number | unknown[]
): string {
  if (!value) {
    return;
  }
  const valueAsNumber = Number(value);
  const localisedValue = valueAsNumber
    .toLocaleString(Vue.config.lang)
    .split('')
    .reverse();
  // all ar-SA numbers are considered NaN
  // checking for the three potential decimal symbols used in EN/FR/AR
  const symbols = ['.', ',', '٫'];
  const findPunctuation = localisedValue.find((element) => {
    const punctuation = symbols.includes(element) ? element : '';
    return punctuation;
  });
  return findPunctuation;
}
